import { createAction } from '@reduxjs/toolkit';
/* for Payment Methods Use */
export var executeCommands = createAction('Commands/EXECUTE_COMMANDS');

/* Commands for User Address Use */
export var saveUserAddressCommands = createAction('Commands/SAVE_USER_ADDRESS_COMMANDS');
export var clearUserAddressCommands = createAction('Commands/CLEAR_USER_ADDRESS_COMMANDS');


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/payment-methods/dist/esm/redux/CommandState/CommandState.actions.js
// module id = 194
// module chunks = 11